import React, {useState} from 'react';
import {connect} from 'react-redux';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import Translate, {t} from "../components/Translate";
import {cancelAction, proceedAction} from "../services/confirmAction/action";
import Input from "./Input";
import TranslateProperty from "../components/TranslateProperty";
import config from "../config";

const style = {
    overlay: {
        backgroundColor: config.modalBackgroundColor,
        zIndex: 2000,
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        borderRadius: '20px',
        transform: 'translate(-50%, -50%)',
        padding: '30px',
        border: 'none',
        width: '1000px',
        maxHeight: '90vh',
        overflow: 'auto',
    },
};

Modal.setAppElement('#root');

const TemplatesViewModal = ({templates, user, cancelActionF, isOpen, handleEditTemplate, handleDeleteTemplate, folderName}) => {
    const [search, setSearch] = useState('');

    const closeModal = () => {
        cancelActionF();
    };

    const filteredTemplates = templates.filter(t =>
        t.text.toLowerCase().includes(search.toLowerCase())
    );

    const handleEditClick = (templateId) => {
        closeModal();
        handleEditTemplate(templateId);
    };

    return (
        <Modal
            closeTimeoutMS={config.closeTimeoutMS}
            isOpen={isOpen}
            style={style}
            onRequestClose={closeModal}
        >
            <div className="templates-modal" style={{maxWidth: '1000px', overflow: 'auto'}}>
                <h2 className="templates-modal-header" style={{marginBottom: '20px'}}>
                    <Translate text={'templates'}/> ({folderName})
                </h2>

                <div style={{marginBottom: '20px'}}>

                    <TranslateProperty properties={[{key: 'placeholder', value: 'search'}]}>
                        <Input
                            isTextarea={true}
                            type="text"
                            placeholder={t({text: 'search', user})}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </TranslateProperty>

                </div>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '20px',
                        marginBottom: '20px',
                    }}
                >
                    {filteredTemplates.map((template, index) => (
                        <div
                            key={index}
                            style={{display: 'flex', alignItems: 'center', gap: '10px'}}
                        >
                            <div style={{
                                backgroundColor: 'rgb(221, 228, 246)',
                                position: 'relative',
                                padding: '15px 40px 15px 15px',
                                border: '1px solid #ddd',
                                borderRadius: '10px',
                                minHeight: '60px',
                                maxHeight: '200px',
                                minWidth: '92%',
                                maxWidth: '92%',
                                wordBreak: 'break-word',
                                overflowY: 'auto',
                                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                                fontSize: '15px',
                                lineHeight: '1.4',
                                display: 'flex',
                                gap: '20px',
                                justifyContent: 'space-between'
                            }}>
                                <span>{template.text}</span>
                            </div>
                            <div style={{display: 'flex'}}>
                                <button className="remove-btn"
                                        onClick={() => {
                                            handleDeleteTemplate(template.id);
                                            closeModal();
                                        }}
                                >
                                    ×
                                </button>
                                <button className="edit-btn"
                                        onClick={() => handleEditClick(template.id)}
                                >
                                    ✎
                                </button>
                            </div>

                        </div>
                    ))}
                </div>
            </div>
        </Modal>
    );
};

TemplatesViewModal.propTypes = {
    templates: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    cancelAction: PropTypes.func.isRequired,
    handleEditTemplate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    isOpen: state.confirmAction.isModalOpen,
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    proceedActionF: () => dispatch(proceedAction()),
    cancelActionF: () => dispatch(cancelAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TemplatesViewModal);



// WEBPACK FOOTER //
// ./src/components-new/TemplatesViewModal.jsx